module.exports = __webpack_public_path__ + "img/ps-37.c550de59.jpg";